// src/feedbackMessages.js

const feedbackMessages = [
    {
      range: [0, 25],
      message: '感謝您完成數碼健康評估。您的結果顯示，您正處於旅程的起點，開始在家培養積極的數碼健康環境、加強關於數碼健康和人工智慧的家庭溝通、建立父母的應變能力和信心，以及強化學校與家長的溝通。這是一個很好的開始，通過關注和支持，您可以逐步養成有效的習慣和策略，以支持您家庭健康且平衡的數碼生活。請記住，前進的每一小步都很重要，我們隨時在此為您提供幫助。',
      actions: [
        {
          text: '試用 Alice，專為家長設計的 AI 數碼育兒虛擬顧問 ',
          label: '認識Alice',
          href: 'https://digital-parenting-assistant.kigulab.com/',
        },
        {
          text: '註冊我們的數碼健康育兒課程 [按鈕即將在此提供]',
          label: '訪問數碼育兒中心',
          href: 'https://www.kigumigroup.com/parenting-in-an-ai-age-articles',
        },
        {
          text: '在此訂閱我們的《AI 時代的育兒之道》電子報',
          label: '訂閱電子報',
          href: 'https://miladevenport.substack.com/p/parenting-in-an-ai-age-11-july-2025?r=1sxor5',
        },
        {
          text: '為您的學校註冊我們的教育平台 KiguLab，以教導您的孩子數碼健康與 AI 倫理',
          label: '訪問Kigulab',
          href: 'https://www.kigumigroup.com/kigulab',
        },
      ],
    },
    {
      range: [26, 50],
      message: '感謝您完成數碼健康評估。您的結果顯示，您已經為在家中創造更健康的數碼環境和促進關於數碼健康與人工智慧的家庭對話邁出了重要的第一步。雖然您已經開始建立管理這些挑戰以及與孩子學校互動的信心，但仍然有很大的成長空間。透過持續的努力和支持，您可以加強您的技能和資源，為您的家庭創造更平衡且連結更緊密的數碼體驗。我們隨時在此為您提供每一步的指導。',
      actions: [
        {
          text: '試用 Alice，專為家長設計的 AI 數碼育兒虛擬顧問 ',
          label: '认识爱丽丝',
          href: 'https://digital-parenting-assistant.kigulab.com/',
        },
        {
          text: '註冊我們的數碼健康育兒課程 [按鈕即將在此提供]',
          label: '访问数字育儿中心',
          href: 'https://www.kigumigroup.com/parenting-in-an-ai-age-articles',
        },
        {
          text: '在此訂閱我們的《AI 時代的育兒之道》電子報',
          label: '订阅时事通讯',
          href: 'https://miladevenport.substack.com/p/parenting-in-an-ai-age-11-july-2025?r=1sxor5',
        },
        {
          text: '為您的學校註冊我們的教育平台 KiguLab，以教導您的孩子數碼健康與 AI 倫理',
          label: '获取 KiguLab',
          href: 'https://www.kigumigroup.com/kigulab',
        },
      ],
    },
    {
      range: [51, 75],
      message: '感謝您完成數碼健康評估。您的結果顯示，您在支持積極的家庭數碼環境、促進關於數碼健康與人工智慧的開放式家庭對話，以及展現作為父母的應變能力和信心方面，已經奠定了良好的基礎。此外，您在校親溝通方面的參與也有一個良好的開始。通過一些重點努力，您可以鞏固這些方面，以提升您家庭的整體數碼健康。',
      actions: [
        {
          text: '試用 Alice，專為家長設計的 AI 數碼育兒虛擬顧問 ',
          label: '认识爱丽丝',
          href: 'https://digital-parenting-assistant.kigulab.com/',
        },
        {
          text: '註冊我們的數碼健康育兒課程 [按鈕即將在此提供]',
          label: '访问数字育儿中心',
          href: 'https://www.kigumigroup.com/parenting-in-an-ai-age-articles',
        },
        {
          text: '為您的學校註冊我們的教育平台 KiguLab，以教導您的孩子數碼健康與 AI 倫理',
          label: '获取 KiguLab',
          href: 'https://www.kigumigroup.com/kigulab',
        },
      ],
    },
    {
      range: [76, 99],
      message: '感謝您完成數碼健康診斷評估。您的結果表明，您在支持家庭數碼健康方面擁有堅實的基礎，尤其是在家中創造積極的環境以及就數碼習慣和人工智慧進行開放式溝通方面。您還展現出作為父母有效的應變能力和信心，並積極參與學校與家長的溝通。為了在這個優秀的基礎上繼續努力，我們鼓勵您探索新的策略和資源，以在當今快速發展的數碼環境中進一步增強您家庭的數碼健康。',
      actions: [
        {
          text: '試用 Alice，專為家長設計的 AI 數碼育兒虛擬顧問 ',
          label: '认识爱丽丝',
          href: 'https://digital-parenting-assistant.kigulab.com/',
        },
        {
          text: '為您的學校註冊我們的教育平台 KiguLab，以教導您的孩子數碼健康與 AI 倫理',
          label: '获取 KiguLab',
          href: 'https://www.kigumigroup.com/kigulab',
        },
      ],
    },
  ];

  export default feedbackMessages;
